import * as React from 'react';

export const cyFlagContent: JSX.Element = (
    <>
        <g clipPath='url(#clip0_1_459)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#F1F5F9'
            />
            <mask
                id='mask0_1_459'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_1_459)'>
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M6.66667 12L13.3333 14.6667V16L5.33333 13.3333L6.66667 12ZM21.3333 12L14.6667 14.6667V16L22.6667 13.3333L21.3333 12ZM13.3333 14.6667H14.6667V17.3333H13.3333V14.6667Z'
                    fill='#4C5B29'
                />
                <path
                    fillRule='evenodd'
                    clipRule='evenodd'
                    d='M6.66667 8C6.66667 8 8 12 12 12C16 12 20 8 20 8H17.3333L21.3333 4L13.3333 6.66667L10.6667 4L9.33333 6.66667L6.66667 8Z'
                    fill='#D77A00'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_1_459'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
        </defs>
    </>
);
